import { render, staticRenderFns } from "./FrameSettings.vue?vue&type=template&id=3038fbce"
import script from "./FrameSettings.vue?vue&type=script&lang=js"
export * from "./FrameSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports